module.exports = __webpack_public_path__ + "static/media/k3-2.5cc468b0.glb";